/**
 * Aria labels for headings and screen recordings. Using + instead of multi-line
 * strings so VoiceOver doesn't pause between lines.
 */

export const accessibilityLabels = {
  /**
   * Alt text for the buses screenshot
   */
  busesScreenshot:
    "Screenshot of the ChiGo app showing nearby bus stops and routes",

  /**
   * Alt text for the Clark & Lake station screenshot
   */
  clarkLakeScreenshot:
    "Screenshot of the ChiGo app showing the Clark & Lake 'L' station " +
    "with departure times for the Blue and Brown lines.",

  /**
   * Alt text for the CTA map screenshot
   */
  ctaMapScreenshot:
    "Screenshot of the ChiGo app showing a map with a Red Line train " +
    "headed towards Lake Street.",

  /**
   * Aria label for the CTA trains video demonstration
   */
  ctaTrainsVideo:
    "Screen recording of the ChiGo app. From the Trains tab, a user taps " +
    "on the Lake Street 'L' station. The app displays departure times for " +
    "the Red Line. The users taps on a departure time and views the Red " +
    "Line train on a map, heading north from Garfield station.",

  /**
   * Aria label for the Metra trains video demonstration
   */
  metraTrainsVideo:
    "Screen recording of the ChiGo app. From the Metra tab, a user taps " +
    "on the Ravenswood U-P North station. The app displays departure times " +
    "for the U-P-N Metra trains. The users taps on a departure time and " +
    "views the Metra train on a map, heading north from Ogilvie " +
    "Transportation Center.",

  /**
   * Aria label for the buses video demonstration
   */
  busesVideo:
    "Screen recording of the ChiGo app. From the Buses tab, a user taps " +
    "on the North Ave & Ashland stop, showing several departure times. " +
    "The user taps on a departure time button and views a map showing a " +
    "bus headed East on North Ave.",

  /**
   * Aria label for the favorites video demonstration
   */
  favoritesVideo:
    "Screen recording of the ChiGo app. From the Favorites tab, a user " +
    "taps on an item labeled 'Western'. The app displays several " +
    "departure times for the Blue Line. The user goes back to the " +
    "Favorites tab and taps on the Ashland & North Ave item, showing " +
    "departure times for the #9 bus. The user goes back and taps on the " +
    "Ravenswood item. The app display several departure times for the " +
    "U-P North Metra trains.",
} as const;
